import ipadAir2 from "./ipad-air-2";
import nexus9 from "./nexus-9";

export default {
	id: "tablets",
	title: "Tablets",
	width: "7em",
	height: "10em",
	items: [ipadAir2, nexus9]
};
